import React from "react";
import {
  StyleSheet,
  TouchableWithoutFeedback,
  View,
  TouchableOpacity,
} from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
import CallIcon from "@assets/svg/CircleCall";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import GoldenStar from "@assets/svg/GoldenStar";
import ChevronRight from "@assets/svg/ChevronRight";
import CompleteReport from "@assets/svg/CompleteReport";
import CustomerSubCard from "./CustomerSubCard";
import PayoutSubCard from "./PayoutSubCard";
import ResultSubCard from "./ResultSubCard";
import TabularResultSubCard from "./TabularResultSubCard";

const SubType = {
  PAYOUT: "PAYOUT",
  CUSTOMER: "CUSTOMER",
  RESULT: "RESULT",
  TABULAR_RESULT: "TABULAR_RESULT",
};
//if array -> length > 0
//if object-> total keys length > 0
const showExpanded = (i) =>
  (Array.isArray(i?.extra_info) && i?.extra_info?.length > 0) ||
  (i?.extra_info && Object.keys(i?.extra_info).length > 0);

function DeliveryPerformanceCard({
  item,
  showModal,
  isHeader = false,
  setModalType = () => {},
  selectedTab = "week",
}) {
  console.log("item", item);
  const renderExpanded = (i, _) => {
    if (i?.subtype === SubType.CUSTOMER) {
      return <CustomerSubCard extra_info={i.extra_info} />;
    } else if (i?.subtype === SubType.PAYOUT) {
      return <PayoutSubCard extra_info={i.extra_info} />;
    } else if (i?.subtype === SubType.RESULT) {
      return <ResultSubCard extra_info={i.extra_info} result={i?.result} />;
    } else if (i?.subtype === SubType.TABULAR_RESULT) {
      return (
        <TabularResultSubCard
          extra_info={i.extra_info}
          result={i?.result}
          setModalType={setModalType}
          selectedTab={selectedTab}
        />
      );
    } else return null;
  };
  return (
    <View style={styles.cardContainer}>
      <View style={styles.header}>
        <View style={styles.headerLeft}>
          {isHeader ? (
            <View style={styles.avatarContainer}>
              <CompleteReport />
            </View>
          ) : (
            <View style={styles.avatarContainer}>
              <Text variant="subtitle_16" style={styles.avatarText}>
                {item?.title?.charAt(0)}
              </Text>
            </View>
          )}
          <Text variant="title_16">{item?.title}</Text>
        </View>
        {!isHeader && (
          <TouchableWithoutFeedback
            onPress={() => handleCallButtonPress(item?.phone_number)}
          >
            <CallIcon />
          </TouchableWithoutFeedback>
        )}
      </View>
      <View style={styles.divider} />
      {item?.report_lines?.map((i, index) => (
        <View
          key={i?.title}
          style={
            showExpanded(i)
              ? styles.expandedContainer
              : styles.collapsedContainer
          }
        >
          <View key={i?.title} style={styles.itemContainer}>
            <TouchableOpacity
              testID="dp-card-item"
              activeOpacity={0.5}
              disabled={true}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Text
                  variant="body_text_3"
                  style={[
                    styles.itemTitle,
                    showExpanded(i) && {
                      color: color.black,
                      fontWeight: "bold",
                    },
                  ]}
                >
                  {i?.title}
                </Text>
                {showExpanded(i) && (
                  <View style={styles.chevronContainer}>
                    <ChevronRight
                      pathFill={color.white}
                      style={[
                        styles.chevronIcon,
                        { transform: [{ rotate: "90deg" }] },
                      ]}
                    />
                  </View>
                )}
              </View>
            </TouchableOpacity>
            <View style={styles.itemValueContainer}>
              {i?.showStar ? (
                <View style={styles.ratingContainer}>
                  <GoldenStar fill="#FFB800" height={18} width={18} />
                </View>
              ) : (
                <Text
                  variant="caption_4"
                  style={[styles.subValue, { color: i?.rating_color }]}
                >
                  {i?.rating_txt}
                </Text>
              )}
              <Text variant="title_18" style={styles.itemValue}>
                {i?.value}
              </Text>
            </View>
          </View>
          {showExpanded(i) && <View>{renderExpanded(i, index)}</View>}
        </View>
      ))}
    </View>
  );
}

export default DeliveryPerformanceCard;

const styles = StyleSheet.create({
  cardContainer: {
    marginHorizontal: 16,
    marginVertical: 10,
    backgroundColor: color.white,
    padding: 16,
    borderRadius: 16,
    paddingHorizontal: 0,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
  },
  avatarContainer: {
    height: 32,
    width: 32,
    borderRadius: 20,
    marginRight: 8,
    backgroundColor: color.pacificBlue,
    justifyContent: "center",
    alignItems: "center",
  },
  avatarText: {
    color: color.white,
  },
  divider: {
    height: 0.5,
    backgroundColor: color.black02,
    marginVertical: 10,
    marginHorizontal: 16,
  },
  itemContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  itemTitle: {
    color: color.mediumBlacklightBlack,
    lineHeight: 18,
  },
  itemValueContainer: {
    flexDirection: "row",
    alignItems: "flex-end",
    height: "100%",
  },
  ratingContainer: {
    marginBottom: 6,
    marginRight: 8,
  },
  subValue: {
    marginRight: 6,
    marginBottom: 2,
    lineHeight: 18,
  },
  itemValue: {
    color: color.black,
  },
  chevronContainer: {
    backgroundColor: color.black,
    padding: 3,
    borderRadius: 4,
    marginLeft: 4,
  },
  chevronIcon: {
    height: 8,
    width: 8,
  },
  expandedContainer: {
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginVertical: 2,
    paddingHorizontal: 12,
    marginHorizontal: 4,
    borderRadius: 16,
    paddingVertical: 8,
  },
  collapsedContainer: {
    marginVertical: 2,
    paddingHorizontal: 12,
    marginHorizontal: 4,
  },
});
